(function(){
  var TARGET="https://sextoycolombia.com/pages/crear-solicitud-mayorista";

  function stripAccents(s){
    try { return (s||"").normalize("NFD").replace(/[\u0300-\u036f]/g,""); }
    catch(e){ return s||""; }
  }
  function norm(s){
    return stripAccents(String(s||"")).toLowerCase().replace(/\s+/g," ").trim();
  }
  function looksLikeMayoristas(text){
    var t = norm(text);
    if(!t) return false;
    return (t.indexOf("mayorist") !== -1) && (t.indexOf("conviert") !== -1 || t.indexOf("convert") !== -1);
  }
  function getText(el){
    if(!el) return "";
    var a = "";
    try { a += " " + (el.textContent || ""); } catch(e){}
    try { a += " " + (el.getAttribute("aria-label") || ""); } catch(e){}
    try { a += " " + (el.getAttribute("title") || ""); } catch(e){}
    return a;
  }

  function fixLinks(root){
    var scope = root || document;
    var links = scope.querySelectorAll ? scope.querySelectorAll("a") : [];
    for(var i=0;i<links.length;i++){
      var a = links[i];
      var txt = getText(a);
      if(looksLikeMayoristas(txt)){
        a.setAttribute("href", TARGET);
        a.setAttribute("data-stc-mayoristas","1");
      }
    }
  }

  // CAPTURE sí, pero SOLO para <a> (NO summary/button => NO rompe el menú)
  document.addEventListener("click", function(ev){
    var a = ev.target && ev.target.closest ? ev.target.closest("a") : null;
    if(!a) return;

    var marked = a.getAttribute("data-stc-mayoristas") === "1";
    var txt = getText(a);

    if(marked || looksLikeMayoristas(txt)){
      try { ev.preventDefault(); } catch(e){}
      window.location.href = TARGET;
    }
  }, true);

  function runAll(){ fixLinks(document); }

  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded", runAll);
  else runAll();

  try {
    var obs = new MutationObserver(function(muts){
      for(var i=0;i<muts.length;i++){
        var m = muts[i];
        if(m.addedNodes) for(var j=0;j<m.addedNodes.length;j++){
          var n = m.addedNodes[j];
          if(n && n.nodeType===1) fixLinks(n);
        }
      }
    });
    obs.observe(document.documentElement,{childList:true,subtree:true});
  } catch(e){}

  setTimeout(runAll, 600);
  setTimeout(runAll, 1600);
})();
